import { createInitializer } from '../../utilities/initializer';

export interface TimeStore {
    displayTime: Date;
}

export const TimeStore = createInitializer<TimeStore>({ displayTime: new Date() });
